import downLoadZip from "./downLoadZip.vue";
import singleFileDownload from "./singleFileDownload.vue";
Vue.prototype.$nsl0 =
  String.fromCharCode(21776) +
  "\u9505\u9e21" +
  String.fromCharCode(20320, 109, 115, 108);
import Vue from "vue";
Vue.component("downLoad-zip", downLoadZip);

const downLoad = new (Vue.extend(downLoadZip))({
  el: document.createElement("div"),
});
// const downLoad = Vue.extend(downLoadZip);
const instance = downLoad;
document.body.appendChild(instance.$mount().$el);
// document.body.appendChild(instance.$mount().$el);

function $downLoadZip(zipname, list, urlName, imgName, suffixName) {
  return instance.onDownload(zipname, list, urlName, imgName, suffixName);
}

function $downLoadDevLineZip(zipname, list, urlName, imgName, suffixName) {
  return instance.onDevAndLine(zipname, list, urlName, imgName, suffixName);
}

Vue.prototype.$downLoadZip = $downLoadZip;
Vue.prototype.$downLoadDevLineZip = $downLoadDevLineZip;

Vue.component("single-download", singleFileDownload);

const singleDownLoad = new (Vue.extend(singleFileDownload))({
  el: document.createElement("div"),
});
document.body.appendChild(singleDownLoad.$mount().$el);

function $singleDownLoad(file, file_title) {
  return singleDownLoad.downloadItem(file, file_title);
}
Vue.prototype.$singleDownLoad = $singleDownLoad;
export default $downLoadZip;
// export default $wx_downloadToast;
